import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import * as React from 'react';

interface ChartProps {
    title: string;
    height: number;
}

export default function OrderBehavior({ title, height = 345 }: ChartProps) {
    const [sales, setSales] = React.useState([]);
    const [totalOrders, setTotalOrders] = React.useState(0);
    const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
    React.useEffect(() => {

        fetch(`/dashboard/order-behavior/?entity_id=${localStorage.getItem('entity_id')}`)
        .then(response => response.json())
        .then(data => {
            setSales(data.sales);
            setTotalOrders(data.total_orders);
        }
        );

        const handleResize = () => {
        if (chartComponentRef.current && chartComponentRef.current.chart) {
            chartComponentRef.current.chart.reflow();
        }
        };

        window.addEventListener('resize', handleResize);
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    function getSubtitle() {
        // Format the totalOrders number with thousand separators
        const formattedTotalOrders = totalOrders.toLocaleString();
        return `<span style="font-size: 14px; text-align: center; font-family: Trebuchet MS;">
                Total Orders: <br/><b>${formattedTotalOrders}</b>
            </span>`;
    }

    const options: Highcharts.Options = {
        chart: {
            type: 'pie',
            plotBackgroundColor: undefined,
            plotBorderWidth: undefined,
            plotShadow: true,
        },
        title: {
            text: title,
            style: {
                fontFamily: 'Trebuchet MS'
            }
        },
        subtitle: {
            text: getSubtitle(),
            floating: true,
            useHTML: true,
            align: 'center',
            verticalAlign: 'middle',
            y: -10
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
            style: {
                fontFamily: 'Trebuchet MS'
            }
        },
        accessibility: {
            point: {
                valueSuffix: '%',
            },
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                    style: {
                        fontFamily: 'Trebuchet MS'
                    }
                },
                innerSize: '60%', // This creates the donut shape
                showInLegend: true,
            },
        },

        legend: {
            itemStyle: {
                fontFamily: 'Trebuchet MS'
            }
        },

        series: [{
            name: 'Order Behavior',
            innerSize: '75%',
            type: 'pie',
            data: sales
        }],
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
            allowChartUpdate={true}
            exportEnabled={true}
            ref={chartComponentRef}
            containerProps={{ style: { width: '100%', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
        />
        </div>
    );
}